module.exports = "<app-header></app-header>\n<app-nav></app-nav>\n<router-outlet (deactivate)=\"onDeactivate()\"></router-outlet>\n<app-footer><app-footer>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main